var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOven(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    x: -144,
    y: -243,
    display: "none",
    fill: "#c3a476",
    width: 544,
    height: 455
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Oven"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c3a476",
    d: "M50,0H14C9.3,0,5,4.3,5,9v46c0,4.7,4.3,9,9,9h36c4.7,0,9-4.3,9-9V9C59,4.3,54.7,0,50,0z M57,55c0,3.7-3.3,7-7,7H14 c-3.7,0-7-3.3-7-7V9c0-3.7,3.3-7,7-7h36c3.7,0,7,3.3,7,7V55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c3a476",
    d: "M46.9,13.9c2.2,0,3.9-1.8,3.9-3.9s-1.8-3.9-3.9-3.9C44.8,6.1,43,7.8,43,10S44.8,13.9,46.9,13.9z M46.9,8.1 c1.1,0,1.9,0.9,1.9,1.9s-0.9,1.9-1.9,1.9S45,11.1,45,10S45.9,8.1,46.9,8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c3a476",
    d: "M37.1,13.9c2.2,0,3.9-1.8,3.9-3.9s-1.8-3.9-3.9-3.9c-2.2,0-3.9,1.8-3.9,3.9S34.9,13.9,37.1,13.9z M37.1,8.1 c1.1,0,1.9,0.9,1.9,1.9s-0.9,1.9-1.9,1.9s-1.9-0.9-1.9-1.9S36,8.1,37.1,8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c3a476",
    d: "M17.1,13.9c2.2,0,3.9-1.8,3.9-3.9s-1.8-3.9-3.9-3.9c-2.2,0-3.9,1.8-3.9,3.9S14.9,13.9,17.1,13.9z M17.1,8.1 c1.1,0,1.9,0.9,1.9,1.9s-0.9,1.9-1.9,1.9s-1.9-0.9-1.9-1.9S16,8.1,17.1,8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c3a476",
    d: "M27.1,13.9c2.2,0,3.9-1.8,3.9-3.9s-1.8-3.9-3.9-3.9c-2.2,0-3.9,1.8-3.9,3.9S24.9,13.9,27.1,13.9z M27.1,8.1 c1.1,0,1.9,0.9,1.9,1.9s-0.9,1.9-1.9,1.9s-1.9-0.9-1.9-1.9S26,8.1,27.1,8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c3a476",
    d: "M48,24H16c-1.7,0-3,1.3-3,3v26c0,1.7,1.3,3,3,3h32c1.7,0,3-1.3,3-3V27C51,25.3,49.7,24,48,24z M49,53c0,0.6-0.4,1-1,1H16 c-0.6,0-1-0.4-1-1V27c0-0.6,0.4-1,1-1h32c0.6,0,1,0.4,1,1V53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c3a476",
    d: "M36,37c0-3.1,1.4-4.1,1.5-4.1c0.5-0.3,0.6-0.9,0.3-1.4c-0.3-0.5-0.9-0.6-1.4-0.4C36.4,31.2,34,32.7,34,37 c0,1.4,0.9,2.7,1.8,3.8c0.6,0.8,1.2,1.7,1.2,2.2c0,1.1-0.9,2.5-2.7,4.3c-0.4,0.4-0.4,1,0,1.4c0.2,0.2,0.5,0.3,0.7,0.3 s0.5-0.1,0.7-0.3C38,46.5,39,44.6,39,43c0-1.2-0.8-2.4-1.6-3.4C36.7,38.7,36,37.7,36,37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c3a476",
    d: "M50,18H14c-0.6,0-1,0.4-1,1s0.4,1,1,1h36c0.6,0,1-0.4,1-1S50.6,18,50,18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c3a476",
    d: "M27,37c0-3.1,1.8-4,1.9-4.1c0.5-0.2,0.7-0.8,0.5-1.3c-0.2-0.5-0.8-0.7-1.3-0.5C27.9,31.2,25,32.6,25,37 c0,1.4,0.9,2.7,1.8,3.8c0.6,0.8,1.2,1.7,1.2,2.2c0,1.4-0.9,2.9-2.6,4.2c-0.4,0.3-0.5,1-0.2,1.4c0.2,0.2,0.5,0.4,0.8,0.4 c0.2,0,0.4-0.1,0.6-0.2C28.8,47,30,45,30,43c0-1.2-0.8-2.4-1.6-3.4C27.7,38.7,27,37.7,27,37z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOven);
export default __webpack_public_path__ + "static/media/oven.de8a780a9909213948abcbddc9c52bc7.svg";
export { ForwardRef as ReactComponent };